<template>
  <div class="interface u-wrapper-panel">
    <div class="interface__logo">
      <img src="/images/loreal--03.png" class="u-full-width u-block">
    </div>
    <!-- <div class="interface__command u-cursor-pointer" @click="$emit('onToggle')">
      <div class="u-box-1by1">
        <div class="u-wrapper-panel interface__command__padding">
          <div class="u-relative u-full-width u-full-height">
            <transition name="t-downscale">
              <svg key="pause" class="u-wrapper-panel u-stroke-transparent u-fill-white t-icon u-fit-contain" v-if="isPlaying" >
                <use xlink:href="#icon-pause"/>
              </svg>
              <svg key="play" class="u-wrapper-panel u-stroke-white t-icon u-fit-contain" v-else >
                <use xlink:href="#icon-play"/>
              </svg>
            </transition>
          </div>
        </div>
      </div>
    </div> -->
    <sequences class="interface__sequences" />
  </div>
</template>

<script>
import Sequences from '@/components/Sequences'

export default {
  components: {
    Sequences
  },

  props: {
    isPlaying: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'

.interface
  &__logo
    position absolute
    top $spacings.md
    left $spacings.md
    width 20%
  
  &__command
    width 5%
    position absolute
    bottom $spacings.md
    right $spacings.md
    border solid 1px $colors.white
    border-radius 50%
    
    &__padding
      padding 30%

  &__sequences
    position absolute
    bottom 50px
    left 50%
    transform translateX(-50%)
</style>